import { useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ProductgroupContext } from '../../store/productgroupContext';

export default function useGetProductgroupName(): {
  getProductgroupName: (id: number | null) => string;
} {
  const { t } = useTranslation('productgroups');
  const { productgroups } = useContext(ProductgroupContext);

  const getProductgroupName = useCallback(
    (id: number | null) => {
      if (id === null) {
        return '';
      }
      const user = productgroups.find((s) => s.id === id);
      if (user && user.name) {
        return user.name;
      }
      return t('unknown');
    },
    [productgroups, t]
  );

  return { getProductgroupName };
}
